import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.recordedItem.isRecording === false && _vm.recordedItem.isEncoding === false)?_c(VBtn,{staticClass:"ma-1",attrs:{"color":"indigo white--text"},on:{"click":_vm.requestTranscribe}},[_c(VIcon,{attrs:{"left":"","dark":""}},[_vm._v("mdi-text-box-outline")]),_vm._v(" transcribe ")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }